import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { API_BASE } from '../../utils/api';
import { Table, Button, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

export default function AdminFollowUps() {
    const [followups, setFollowups] = useState<any>({ today: [], upcoming: [], overdue: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDashboard();
    }, []);

    const fetchDashboard = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('resido_token');
            const res = await fetch(`${API_BASE}/leads/followups/dashboard`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (res.ok) {
                setFollowups(data.today ? data : { today: [], upcoming: [], overdue: [] });
            } else {
                toast.error(data.message || 'Failed to load follow-ups');
            }
        } catch (err) {
            toast.error('Failed to load follow-ups');
        } finally {
            setLoading(false);
        }
    };

    const renderTable = (list: any[], title: string, color: string) => (
        <div className="card border-0 shadow-sm rounded-4 mb-4">
            <div className={`card-header bg-white py-3 border-0 border-start border-4 border-${color}`}>
                <h6 className="fw-bold mb-0 text-dark">{title} ({list.length})</h6>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <Table hover borderless className="align-middle mb-0">
                        <thead className="bg-light small fw-bold text-muted">
                            <tr>
                                <th className="ps-4">Customer</th>
                                <th>Lead Status</th>
                                <th>Schedule</th>
                                <th className="text-end pe-4">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.length === 0 ? (
                                <tr><td colSpan={4} className="text-center py-4 text-muted small">No follow-ups for this category.</td></tr>
                            ) : list.map((f: any) => (
                                <tr key={f._id} className="border-bottom-0">
                                    <td className="ps-4">
                                        <div className="fw-bold text-dark">{f.lead?.name}</div>
                                        <div className="small text-muted">{f.lead?.mobile}</div>
                                    </td>
                                    <td><Badge bg="light" className="text-primary rounded-pill">{f.lead?.status}</Badge></td>
                                    <td>
                                        <div className="small fw-bold">{new Date(f.followUpDate).toLocaleDateString()}</div>
                                        <div className="small text-muted">{f.followUpTime || 'Not set'}</div>
                                    </td>
                                    <td className="text-end pe-4">
                                        <Button variant={`outline-${color}`} size="sm" className="rounded-pill px-3 fw-bold">Call Now</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );

    return (
        <AdminLayout>
            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"></div></div>
            ) : (
                <div className="row g-4">
                    <div className="col-lg-8">
                        {renderTable(followups.today, "Today's Follow-Ups", "primary")}
                        {renderTable(followups.overdue, "Overdue Tasks", "danger")}
                    </div>
                    <div className="col-lg-4">
                        {renderTable(followups.upcoming, "Upcoming", "info")}

                        <div className="card border-0 shadow-sm rounded-4 bg-dark text-white p-4">
                            <h5 className="fw-bold mb-3"><i className="fa-solid fa-lightbulb text-warning me-2"></i>Sales Tip</h5>
                            <p className="small opacity-75 mb-0">Follow-ups within 24 hours of a site visit increase booking chances by 40%. Keep your pipeline moving!</p>
                        </div>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
}


